import * as React from 'react'
import SVG from 'react-inlinesvg'
import { Button } from 'relevant-ui'
import ICON_VALIDATE from 'assets/icon-validate.svg'

class Congratulation extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <div className="customform customform--padding" style={{}}>
        <p className="customform__title customform__title--center" style={{ marginBottom: '10px', marginTop: '0' }}><SVG src={ICON_VALIDATE} /></p>
        <p className="customform__title customform__title--center" style={{ margin: '0 0 10px 0' }}>Bravo !</p>
        <p className="customform__desc" style={{ textAlign: 'center', marginBottom: '52px' }}>
          La double authentification est activée sur votre compte !
        </p>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            button="primary"
            size="large"
            disabled={false}
            label="Fermer"
            onClick={() => this.props.onSubmit()}
          />
        </div>
      </div>
    )
  }
}

export default Congratulation
